(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-homepage"] && !Shopify.designMode) return;
  try {
    

  $(document).ready( function(){
    toggleAnswer();
  }
  )

// to hide and show the answer of faqs

function toggleAnswer(){
    $('.question--container').next('.answer--container').slideUp(300);
    $('.question--container').click( function(){
    /*  $('.question--container').next('.answer--container').slideUp(300); */
        $(this).next('.answer--container').slideToggle(300);
    $('.answer--container').click( function(){
        $(this).slideUp(300);
  })
  })
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    

    const queAns =[
        {
            "id": 1,
            "name": "General questions",
            "data": `
        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">Where is your company based?</h3>
            </div>
            <div class="answer--container">
                We are based in India and are licensed by the Ministry of Health, India. We are also compliant with WHO Good Distribution Practices.
            </div>
        </div>



        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">How can I trust you?</h3>
            </div>
            <div class="answer--container">
                We have a decade of experience in shipping medicines to patients in various countries. We have
helped more than 25000 patients till date. We also welcome any other queries for verification.
            </div>
        </div>

        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> Are medicines from India safe? </h3>
            </div>
            <div class="answer--container">
                As per IQVIA and other international reports, India supplies more than 50% of all generics. In fact,
around 40% of all generics in the US and 25% of all generics in the UK are manufactured in India.
As is the case with any country, there are all types of companies and people. Hence, it is best to do
your due diligence and ensure that the indicators, information and communication is transparent.
            </div> 
        </div> 
        `
        },
        {
            "id": 2,
            "name": "Regulations FAQs",
            "data": `
            <div class="faq-que-ans--inner-container">
                <div class="question--container">
                    <h3 class="que-title">Is it legal to import medicines for personal use?</h3>
                </div>
                <div class="answer--container">
                   There are many countries which allow import of limited quantity of medicines strictly for personal
use. This is possible with a doctor's prescription and depending on the country, some additional
requirements.
                </div>
            </div>



            <div class="faq-que-ans--inner-container">
                <div class="question--container">
                    <h3 class="que-title">What are the regulations for personal importation in my country?</h3>
                </div>
                <div class="answer--container">
                    To know specifically about the requirements in your country, please get in touch with us <a href="https://medspartner.myshopify.com//pages/contact">here</a>.
                </div>
            </div>

            <div class="faq-que-ans--inner-container">
                <div class="question--container">
                    <h3 class="que-title"> Do I need a prescription for importing my medicines?</h3>
                </div>
                <div class="answer--container">
                    Yes, we can help you only with a valid prescription from your treating doctor.
                </div> 
            </div> 

            <div class="faq-que-ans--inner-container">
                <div class="question--container">
                    <h3 class="que-title"> I am a little concerned about the whole process, since it is new to me. What shall I do?</h3>
                </div>
                <div class="answer--container">
                    Please reach out to us with your requirements and concerns. We will try our best to handhold you
through the process.
                </div> 
            </div>
            `
        },
        {
            "id": 3,
            "name": "Product FAQs",
            "data": `
        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">How can I be assured of the quality of medicines?</h3>
            </div>
            <div class="answer--container">
                All the products offered on our platform are manufactured in facilities which are audited and
approved by strict regulatory authorities like USFDA or EMEA or PIC/s. Moreover, all products are
sourced directly from the respective manufacturers or their authorized representatives.
            </div>
        </div>



        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">Do you deal in Controlled medicines and/or Narcotics?</h3>
            </div>
            <div class="answer--container">
                We do not deal in any controlled medicines or Narcotics.
            </div>
        </div>

        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> I cannot find the medicine required by me on your website. Can you help with it?</h3>
            </div>
            <div class="answer--container">
                You may submit your requirement along with the prescription. We will let you know if we can help.
            </div> 
        </div> `
        },
        {
            "id": 4,
            "name": "Shipping, Payment and Customs clearance FAQs",
            "data": `
        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">How many months of medicine can I order?</h3>
            </div>
            <div class="answer--container">
                As per your country's regulations, you may be permitted to import quantities equivalent to 1 month
to 6 months of treatment. Most countries permit upto 3months of medicines. We will let you know
the permissible quantities upon your enquiry.
            </div>
        </div>



        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">How do you ship the medicines?</h3>
            </div>
            <div class="answer--container">
               We use Express shipping like DHL, Fedex and International EMS post for your parcels.
            </div>
        </div>

        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> How long does it take for the medicines to arrive? </h3>
            </div>
            <div class="answer--container">
                We ship your medicines within 1-2 working days of receipt of payment. It usually takes between 7 to
14 days for your medicines to reach you.
            </div> 
        </div> 


        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> What payment modes do you offer? </h3>
            </div>
            <div class="answer--container">
                We offer International SWIFT transfer for payment. Unfortunately, we are unable to accept credit
cards at the moment due to the international regulations related to payment gateways for
international pharmacies.
            </div> 
        </div> 

        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> Who is responsible for the payment of duties and taxes in my country?</h3>
            </div>
            <div class="answer--container">
                Any duties or taxes applied by your country’s customs authorities have to paid by you directly to the
concerned customs department or logistics provider.
            </div> 
        </div> 

        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> How will my medicines get cleared through customs in my country?</h3>
            </div>
            <div class="answer--container">
                Our team does our best to take care of all the requirements in advance and enclose all the required
documents with the shipment. Still sometimes, the customs department may ask for additional
information from your end. In most cases, it gets resolved after providing the required information.
            </div> 
        </div> 
        `
        },
        {
            "id": 5,
            "name": "cancel",
            "data": `
        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">Question 1 Cancel</h3>
            </div>
            <div class="answer--container">
                Answer1
            </div>
        </div>



        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title">Question 2</h3>
            </div>
            <div class="answer--container">
                Answer2
            </div>
        </div>

        <div class="faq-que-ans--inner-container">
            <div class="question--container">
                <h3 class="que-title"> Question 3 </h3>
            </div>
            <div class="answer--container">
                Answer3
            </div> 
        </div> `
        }
    ]

    const queAnsSection = document.querySelector('.faq-tab--nav-container');
    const navigationBtns = document.querySelectorAll('.faq-list-item--container')
    const listBtns = document.querySelectorAll('.faq-list-item')

    const faqMainContainer = document.querySelector('.faq-que-ans--outer-container');

    console.log(queAnsSection)

            queAnsSection.addEventListener('click', (e)=>{

                console.log(e.target)
                
                    console.log(e.target.dataset.id)
                    let navigationID = e.target.dataset.id;


                    // to change the color of navigation in left
                if(navigationID ){
                    navigationBtns.forEach((btn)=>{
                        btn.classList.remove('active')
                        e.target.classList.add('active')
                    })
                    listBtns.forEach((btn)=>{
                        btn.classList.remove('active');
                        e.target.classList.add('active')
                    })
                
          
                // to update the content on the right hand side
                if( navigationID == "about"){
                    faqMainContainer.innerHTML = queAns[0].data
                    
                }

                else if( navigationID == "legal"){
                    faqMainContainer.innerHTML = queAns[1].data
                }
                else if( navigationID == "how-to-buy"){
                    faqMainContainer.innerHTML = queAns[2].data
                }
                else if( navigationID == "delivery"){
                    faqMainContainer.innerHTML = queAns[3].data
                }
                else if( navigationID = "cancel"){
                    faqMainContainer.innerHTML = queAns[4].data
                }
            }
            toggleAnswer();
            
  })
 

  $(document).ready( function(){
    toggleAnswer();
  }
  )

// to hide and show the answer of faqs

function toggleAnswer(){
    $('.question--container').next('.answer--container').slideUp(300);
    $('.question--container').click( function(){
   /*   $('.question--container').next('.answer--container').slideUp(300); */
        $(this).next('.answer--container').slideToggle(300);
  })
  $('.answer--container').click( function(){
   /*   $('.question--container').next('.answer--container').slideUp(300); */
        $(this).slideUp(300);
  })
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
